/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Scan_DescriptionInputs */



/**
* | output |
* | --- |
* | "Hold your cards in front of the camera to add them to a collection, recognised on your device so no pictures are uploaded." |
*
* @param {Nav_Locked_Scan_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_scan_description = /** @type {((inputs?: Nav_Locked_Scan_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Scan_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Halte deine Karten vor die Kamera, um sie einer Sammlung hinzuzufügen. Die Erkennung läuft auf deinem Gerät, es werden keine Bilder hochgeladen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Présentez vos cartes à la caméra pour les ajouter à une collection. La reconnaissance se fait sur votre appareil, aucune image n'est envoyée.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("把卡牌举到摄像头前即可加入收藏，识别在你的设备上完成，不会上传任何图片。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("把卡牌拿到相機前就能加入收藏，辨識在你的裝置上完成，不會上傳任何照片。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카메라 앞에 카드를 들면 컬렉션에 추가됩니다. 기기 안에서 인식하므로 사진은 전송되지 않습니다.")
	return /** @type {LocalizedString} */ ("Hold your cards in front of the camera to add them to a collection, recognised on your device so no pictures are uploaded.")
});